import React from 'react';
import { Dialog, DialogContent, Typography } from '@mui/material';
import { ColorPalette } from '../../../styles/constants';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

interface Props {
  isOpen: boolean;
  message: string | null;
  onClose(): void;
}

export function AppConfirmationSuccessful({
  isOpen,
  message,
  onClose,
}: Props): JSX.Element {
  return (
    <Dialog open={isOpen} fullWidth onClose={onClose} maxWidth="xs">
      <DialogContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: 200,
        }}
      >
        <TaskAltIcon sx={{ color: ColorPalette.GREEN }} fontSize="large" />
        <Typography variant="h6" sx={{ mt: 3 }}>
          {message}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
